import { ReactComponent as BotIcon } from "assets/Imgs/telegram.svg";
import { ReactComponent as MessageIcon } from "assets/Imgs/message.svg";
import { ReactComponent as ChatBubbleIcon } from "assets/Imgs/chat_bubble.svg";
import { ReactComponent as HeartIcon } from "assets/Imgs/heart.svg";
import { ReactComponent as FillProfileIcon } from "assets/Imgs/arrow_fill_profile.svg";
import { ReactComponent as LikeIcon } from "assets/Imgs/like.svg";
import { ReactComponent as InfoIcon } from "assets/Imgs/exclamation.svg";
import { ReactComponent as StarIcon } from "../Rating/assets/star.svg";

const openNotificationHelp = () => {
    // Determine the user's browser
    var browser = navigator.userAgent.toLowerCase();

    // Define the URLs for the notification help pages for different browsers
    var urls = {
        chrome: "https://support.google.com/chrome/answer/114662",
        firefox: "https://support.mozilla.org/en-US/kb/push-notifications-firefox",
        edge: "https://support.microsoft.com/en-us/microsoft-edge/manage-website-notifications-in-microsoft-edge-0c555609-5bf2-479d-a59d-fb30a0b80b2b",
        safari: "https://support.apple.com/guide/safari/customize-website-notifications-sfri40734/mac",
        // Add more browsers as needed
    };

    // Determine which URL to use
    var url;
    if (browser.includes("chrome") && !browser.includes("edg")) {
        url = urls.chrome;
    } else if (browser.includes("firefox")) {
        url = urls.firefox;
    } else if (browser.includes("edg")) {
        url = urls.edge;
    } else if (browser.includes("safari") && !browser.includes("chrome")) {
        url = urls.safari;
    } else {
        // If the browser is not recognized, you might direct the user to a general help page
        url = "https://support.humblebundle.com/hc/en-us/articles/360008513933-Enabling-and-Disabling-Browser-Notifications-in-Various-Browsers";
    }

    // Open the URL in a new tab
    window.open(url, '_blank');
}



export const splitContent = (content, deepLinkText) => {
    content = content || '';
    deepLinkText = deepLinkText || '';
    const sanitizedDeepLinkText = deepLinkText.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    return deepLinkText
        ? content.split(new RegExp(`(${sanitizedDeepLinkText})`, 'i'))
        : [content];
}

export const formatTimeAgo = (timestamp, locale = 'en') => {
    const currentTime = Date.now();
    const timeDifferenceInSeconds = Math.floor((currentTime - timestamp) / 1000);

    const rtf = new Intl.RelativeTimeFormat(locale,
        {
            numeric: 'auto',
            style: 'short',
            localeMatcher: 'best fit'
        });

    if (timeDifferenceInSeconds < 60) {
        return rtf.format(-timeDifferenceInSeconds, 'second');
    }

    if (timeDifferenceInSeconds < 3600) {
        const minutes = Math.floor(timeDifferenceInSeconds / 60);
        return rtf.format(-minutes, 'minute');
    }

    if (timeDifferenceInSeconds < 86400) {
        const hours = Math.floor(timeDifferenceInSeconds / 3600);
        return rtf.format(-hours, 'hour');
    }

    if (timeDifferenceInSeconds < 604800) {
        const days = Math.floor(timeDifferenceInSeconds / 86400);
        return rtf.format(-days, 'day');
    }

    if (timeDifferenceInSeconds < 2419200) {
        const weeks = Math.floor(timeDifferenceInSeconds / 604800);
        return rtf.format(-weeks, 'week');
    }

    const months = Math.floor(timeDifferenceInSeconds / 2419200);
    return rtf.format(-months, 'month');
}

export const isAction = (item) => {
    return [
        "ACTION_FEEDBACK",
        "ACTION_FILL_PROFILE",
        "ACTION_INFO",
        "ACTION_CONFIRM_EMAIL",
        "ACTION_CONNECT_BOT",
        "ACTION_COMPLETE_ONBOARDING",
        "ACTION_GRANT_PERMS"
    ].includes(item.type);
}

export const enrichNotification = (notification, langMap) => {
    let data = {};
    const type = notification.type;
    switch (type) {
        case "ACTION_FILL_PROFILE":
            const percent = parseFloat(notification.content) * 100 + "%";
            data.content = langMap.fillProfile;
            data.deepLinkText = langMap.fillProfileUrl;
            data.deepLinkUrl = "/profile";
            data.badge = <><FillProfileIcon title={percent} /><label>{percent}</label></>;
            break;
        case "ACTION_FEEDBACK":
            data.deepLinkText = langMap.rateMeeting;
            data.deepLinkUrl = "/contacts";
            data.badge = <StarIcon />;
            break;
        case "ACTION_CONFIRM_EMAIL":
            data.content = langMap.confirmEmail;
            data.deepLinkText = langMap.confirmEmailUrl;
            data.deepLinkUrl = "/last-step";
            data.badge = <MessageIcon />;
            break;
        case "ACTION_GRANT_PERMS":
            data.title = langMap.grantPermissionsTitle;
            data.content = langMap.grantPermissions;
            data.deepLinkText = langMap.grantPermissionsUrl;
            data.avaClick = openNotificationHelp
            data.badge = <InfoIcon />;
            break;
        case "MATCH":
            data.deepLinkUrl = "/contacts";
            data.badge = <HeartIcon />;
            break;
        case "LIKE":
            data.deepLinkUrl = "/u/" + notification.relatedUser?.slug || "/participants";
            data.badge = <LikeIcon />;
            break;
        case "ACTION_CONNECT_BOT":
            data.badge = <BotIcon />;
            break;
        case "ACTION_COMPLETE_ONBOARDING":
            data.deepLinkUrl = data.deepLinkUrl || "/questions";
            data.badge = <InfoIcon />;
            break;
        case "MENTORSHIP_REQUEST":
        case "MENTORSHIP_CANCELLED":
            data.deepLinkUrl = notification.deepLinkUrl || "/mentorship?tab=incoming";
            data.badge = <HeartIcon />;
            break;
        case "MENTORSHIP_ACCEPTED":
        case "MENTORSHIP_DECLINED":
            data.deepLinkUrl = notification.deepLinkUrl || "/mentorship?tab=outgoing";
            data.badge = <HeartIcon />;
            break;
        case "MESSAGE":
            data.badge = <ChatBubbleIcon />;
            break;

    }
    return { ...notification, ...data }
}

export const defaultNotifications = {
    new: [],
    seen: [],
    actions: [],
    flat: []
}